var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMachineUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-machine_user"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "machine_user",
    "data-name": "machine user",
    clipPath: "url(#clip-machine_user)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2697",
    "data-name": "Rectangle 2697",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11133",
    "data-name": "Group 11133",
    transform: "translate(3.646 3.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6240",
    "data-name": "Group 6240",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6182",
    "data-name": "Group 6182",
    transform: "translate(2.885 3.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2688",
    "data-name": "Rectangle 2688",
    width: 2.08,
    height: 2.379,
    rx: 1,
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    width: 2.08,
    height: 2.379,
    rx: 1,
    transform: "translate(3.693)",
    fill: "#377ef3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11188",
    "data-name": "\\u30D1\\u30B9 11188",
    d: "M6951.818-2829.187h-1.008V-2843.8a.5.5,0,0,1,.5-.5h10.535v1.008h-10.031Z",
    transform: "translate(-6950.811 2844.305)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_321",
    "data-name": "\\u7DDA 321",
    d: "M5.9.008H-.5A.5.5,0,0,1-1-.5.5.5,0,0,1-.5-1H5.9a.5.5,0,0,1,.5.5A.5.5,0,0,1,5.9.008Z",
    transform: "translate(1 15.487)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_322",
    "data-name": "\\u7DDA 322",
    d: "M-.5,8.575a.5.5,0,0,1-.5-.5V-.5A.5.5,0,0,1-.5-1a.5.5,0,0,1,.5.5V8.071A.5.5,0,0,1-.5,8.575Z",
    transform: "translate(11.583 1)",
    fill: "#377ef3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11132",
    "data-name": "Group 11132",
    transform: "translate(3.961 6.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3819",
    "data-name": "Group 3819",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_56",
    "data-name": "\\u9577\\u65B9\\u5F62 56",
    d: "M.372-1H7.455a1.372,1.372,0,1,1,0,2.743H.372A1.372,1.372,0,1,1,.372-1ZM7.455.735a.364.364,0,1,0,0-.727H.372a.364.364,0,1,0,0,.727Z",
    transform: "translate(3.92 8.073)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(3.603 2.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_638",
    "data-name": "\\u30D1\\u30B9 638",
    d: "M154.461,262.688h-3.726a.5.5,0,0,1-.5-.5v-2.422a.5.5,0,0,1,.07-.256l1.428-2.422a.5.5,0,0,1,.434-.248h2.3a.5.5,0,0,1,.5.5v4.844A.5.5,0,0,1,154.461,262.688Zm-3.222-1.008h2.718v-3.836h-1.506l-1.212,2.056Z",
    transform: "translate(-150.231 -256.836)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_57",
    "data-name": "\\u9577\\u65B9\\u5F62 57",
    d: "M-.5-1H3.076a.5.5,0,0,1,.5.5V1.491a.5.5,0,0,1-.5.5H-.5a.5.5,0,0,1-.5-.5V-.5A.5.5,0,0,1-.5-1ZM2.572.008H.008V.987H2.572Z",
    transform: "translate(4.726 3.857)",
    fill: "#377ef3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_639",
    "data-name": "\\u30D1\\u30B9 639",
    d: "M147.167,263.654h-2.086a.5.5,0,0,1-.5-.5v-2.066a.5.5,0,0,1,.859-.358l2.086,2.066a.5.5,0,0,1-.355.862Zm-1.582-1.008h.357l-.357-.354Z",
    transform: "translate(-144.577 -256.271)",
    fill: "#377ef3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_640",
    "data-name": "\\u30D1\\u30B9 640",
    d: "M145.081,258.2a.5.5,0,0,1-.469-.688l1.719-4.387a.5.5,0,0,1,.826-.172l2.668,2.668a.5.5,0,0,1-.713.713l-2.123-2.123-1.438,3.67A.5.5,0,0,1,145.081,258.2Z",
    transform: "translate(-144.577 -252.802)",
    fill: "#377ef3"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMachineUser);
export default __webpack_public_path__ + "static/media/icon_machine_user.3abef787dfaaa25fe6d3501aeafb10d9.svg";
export { ForwardRef as ReactComponent };